import { Title } from '@angular/platform-browser';
import {
  trigger,
  state,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { lastValueFrom, map, Observable, throwError } from 'rxjs';
import { PageItem } from 'src/app/models/portal';
import {
  AuthenticationService,
  ApiService,
} from '../../../../../shared/services';
import { UserDashboardService } from '../../../../../shared/services/user-dashboard.service';
import { PromptingService } from 'src/app/shared/services';
import { MailServiceStatus } from '../../portal.model';
import {
  PortalViewPageStatusEnum,
  SharedPortalViewService,
} from '../shared-portal-view.service';
import { Store } from '@ngrx/store';
import { Country } from 'src/app/models/country';
import {
  selectWebsiteAggregateAnalytics,
  isWebsiteAggregateAnalyticsLoaded,
} from 'src/app/shared/store/_features/website/analytics/website-analytics.selector';
import { getWebsiteMainAnalyticsActions } from 'src/app/shared/store/_features/website/analytics/website-analytics.actions';
import { PeriodResultModel } from 'src/app/models/owner-dashboard';
import { PeriodTypeValue } from 'src/app/models/dashboard.shared';

import { ApexOptions } from 'ng-apexcharts';
import { LearmoUtil } from 'src/app/shared/utils';

import * as Highcharts from 'highcharts/highmaps';
import worldMap from '@highcharts/map-collection/custom/world.geo.json';

export enum PortalNavigatorEnum {
  site_settings,
  pages,
  site_apperances,
}

export enum PagesFilterNavigatorEnum {
  all,
  published,
  draft,
}

@Component({
  selector: 'app-portal-overview',
  templateUrl: './portal-overview.component.html',
  styleUrls: ['./portal-overview.component.css'],
  animations: [],
})
export class PortalOverviewComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor = 'mapChart';
  mapOptions: Highcharts.Options;
  mapInitialized = false;
  chart: Highcharts.Chart;
  hoveredCountryCode: string = null;

  analytics: any;
  analyticsSubscription$ = this.store.select(selectWebsiteAggregateAnalytics);
  analyticsLoaded$: Observable<boolean> = this.store.select(
    isWebsiteAggregateAnalyticsLoaded,
  );

  mailServiceStatus: MailServiceStatus = MailServiceStatus.not_configured;
  userMailOptionsSize: number;
  userMailOptions: any;

  websiteScreenshot: any;

  private isPolling = true;
  currentVisitorsCount: number;

  periodLimits: PeriodTypeValue = {
    startDate: Math.floor(new Date().getTime() / 1000),
    endDate: Math.floor(new Date().getTime() / 1000),
  };

  pageData: { period: PeriodResultModel } = {
    period: null,
  };
  constructor(
    private renderer: Renderer2,
    private route: Router,
    private aroute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private api: ApiService,
    private userDashboardService: UserDashboardService,
    public sharedPortalViewService: SharedPortalViewService,
    private title: Title,
    private store: Store,
    private prompting: PromptingService,
  ) {
    this.sharedPortalViewService.setPageStatus(
      PortalViewPageStatusEnum.overview,
    );

    this.store
      .select(selectWebsiteAggregateAnalytics)
      .subscribe((analytics) => {
        this.analytics = analytics;
        this.sortTopPages();
        if (analytics?.topCountries) {
          this.prepareMapChart(analytics.topCountries);
        }
      });
  }

  topPagesSortKey: 'pageviews' | 'visitors' = 'pageviews';

  sortTopPages(key?: 'pageviews' | 'visitors') {
    if (key) {
      this.topPagesSortKey = key;
    }

    if (this.analytics?.topPages?.length) {
      const sortedPages = [...this.analytics.topPages].sort((a, b) => {
        return (b[this.topPagesSortKey] || 0) - (a[this.topPagesSortKey] || 0);
      });
      // We update the local analytics object with sorted pages
      this.analytics = { ...this.analytics, topPages: sortedPages };
    }
  }

  async ngOnInit() {
    await this.getPortalMailingServiceStatus();
    this.getWebsiteScreenshot();
    // await this.sharedPortalViewService.getPaymentMethods();
    await this.sharedPortalViewService.getUserDomains();
    this.title.setTitle(
      this.sharedPortalViewService.currentWebsite.website.label +
        ' > ' +
        'Overview',
    );
  }

  async onPeriodChange(value: PeriodResultModel) {
    this.pageData.period = value;
    this.store.dispatch(
      getWebsiteMainAnalyticsActions.load({ period: value?.period }),
    );
  }

  async getWebsiteScreenshot() {
    let request$ = this.api.screenshot(
      `https://${this.sharedPortalViewService.currentWebsite.website.siteUrl}`,
      false,
      this.screenshotErrorHandler,
    );
    let response = await lastValueFrom(request$);

    this.websiteScreenshot = response.img;
  }

  screenshotErrorHandler = (e: HttpErrorResponse) => {};
  async setDomainMailingService() {
    if (this.mailServiceStatus == MailServiceStatus.not_configured) {
      this.route.navigateByUrl('profile/mailing');
    } else {
      this.prompting.success('All done!', '', 'md');
      // .queue([
      //   {
      //     html:
      //       'Choose an outgoing email for this Domain.<br>This is the email that your subscribers<br>will see in the FROM field <div class="input-group mt-3"><select style="height: 3.2em;" id="mailingEmail" class="form-control" placeholder="Username" aria-describedby="basic-addon2"><option value="noreply">noreply</option><option value="newsletter">newsletter</option><option value="subscribe">subscribe</option><option value="marketing">marketing</option></select><div class="input-group-append"><span class="input-group-text" id="basic-addon2">' +
      //       '@' +
      //       this.sharedPortalViewService.currentWebsite.website.siteUrl.replace(
      //         'www.',
      //         ''
      //       ) +
      //       '</span></div>',
      //     preConfirm: () => {
      //       mailingEmail =
      //         (document.getElementById('mailingEmail') as HTMLInputElement)
      //           .value +
      //         '@' +
      //         this.sharedPortalViewService.currentWebsite.website.siteUrl.replace(
      //           'www.',
      //           ''
      //         );
      //     },
      //   },
      //   {
      //     html: 'Pick a SMTP Account to use for this Domain<br>You can Configure additional accounts under <a href="profile/mailing">SMTP Settings</a>',
      //     input: 'select',
      //     inputOptions: this.userMailOptions,
      //     allowOutsideClick: false,
      //     inputAttributes: {
      //       style:
      //         'height: 2.7em;border-radius: 5px;border: 1px solid #ced4da;',
      //       autocapitalize: 'off',
      //     },
      //     confirmButtonText: 'Proceed',
      //     showLoaderOnConfirm: true,
      //     preConfirm: (mailingService) => {
      //       return this.api
      //         .updatePortalMail(
      //           +this.sharedPortalViewService.currentWebsite.id,
      //           +mailingService,
      //           mailingEmail,
      //           this.handleError
      //         )
      //         .toPromise()
      //         .then((response) => {
      //           this.mailServiceStatus = MailServiceStatus.pending;
      //           Swal.fire({
      //             icon: 'success',
      //             title: 'All done!',
      //             confirmButtonText: 'OK!',
      //           });
      //         })
      //         .catch((error) => {
      //           Swal.showValidationMessage(`Request failed: ${error}`);
      //         });
      //     },
      //   },
      // ]);
    }
  }

  async getMailingData() {
    const data = await this.api.getUserMailServices().toPromise();
    const userMailService: Map<
      number,
      { mailServiceId: number; mailServiceName: string; apiKey: string }
    > = data.data;
    this.userMailOptions = new Map();

    for (const key in userMailService) {
      if (Object.prototype.hasOwnProperty.call(userMailService, key)) {
        const a = userMailService[key];
        this.userMailOptions.set(a.mailServiceId, a.mailServiceName);
      }
    }
    this.userMailOptionsSize = this.userMailOptions.size;
  }

  async getPortalMailingServiceStatus() {
    // await this.getMailingData();
    // if (this.sharedPortalViewService.currentWebsite.website.isFree) {
    // } else {
    //   if (
    //     this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
    //     this.sharedPortalViewService.currentWebsite.website.isVerified &&
    //     this.userMailOptionsSize > 0
    //   ) {
    //     this.mailServiceStatus = MailServiceStatus.activated;
    //   } else if (
    //     this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
    //     !this.sharedPortalViewService.currentWebsite.website.isVerified &&
    //     this.userMailOptionsSize > 0
    //   ) {
    //     this.mailServiceStatus = MailServiceStatus.pending;
    //   } else if (
    //     !this.sharedPortalViewService.currentWebsite.website.isLinkedWithEmailService &&
    //     !this.sharedPortalViewService.currentWebsite.website.isVerified &&
    //     this.userMailOptionsSize > 0
    //   ) {
    //     this.mailServiceStatus = MailServiceStatus.configured;
    //   } else {
    //     this.mailServiceStatus = MailServiceStatus.not_configured;
    //   }
    // }
  }

  restoreCopyuserurl(objectID: string) {
    const copyBut = document.getElementById(objectID);
    // copyBut.setAttribute('style', 'background: transparent');
    copyBut.classList.value = '';
    copyBut.innerText = '';
  }

  onChartInstance(chart: Highcharts.Chart) {
    this.chart = chart;
  }

  onTableCountryHover(countryCode: string) {
    this.hoveredCountryCode = countryCode?.toLowerCase();
    if (this.chart && this.hoveredCountryCode) {
      const point = this.chart.get(this.hoveredCountryCode) as Highcharts.Point;
      if (point && point.setState) {
        point.setState('hover');
        if (point.series && point.series.chart && point.series.chart.tooltip) {
          point.series.chart.tooltip.refresh(point);
        }
      }
    }
  }

  onTableCountryLeave() {
    this.hoveredCountryCode = null;
    if (this.chart) {
      this.chart.series.forEach((s) => {
        s.points.forEach((p) => {
          if (p.setState) {
            p.setState('');
          }
        });
      });
      if (this.chart.tooltip) {
        this.chart.tooltip.hide();
      }
    }
  }

  prepareMapChart(countries: any[]) {
    const mapData = countries.map((c) => {
      const code = c.countryItem?.code?.toLowerCase() || c.name.toLowerCase();
      return {
        id: code,
        'hc-key': code,
        'iso-a2': code.toUpperCase(),
        name: c.countryItem?.name || c.name,
        value: c.visitors,
      };
    });

    if (!this.mapInitialized) {
      this.mapOptions = this.getMapOptions(mapData);
      this.mapInitialized = true;
    } else {
      (this.mapOptions.series[0] as any).data = mapData;
      this.mapOptions = { ...this.mapOptions }; // Trigger change detection
    }
  }

  getMapOptions(data: any[]): Highcharts.Options {
    return {
      chart: {
        backgroundColor: 'transparent',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      mapNavigation: {
        enabled: true,
        buttonOptions: {
          verticalAlign: 'bottom',
        },
      },
      plotOptions: {
        series: {
          point: {
            events: {
              mouseOver: (e) => {
                const point = e.target as any;
                this.hoveredCountryCode = point.id;
              },
              mouseOut: () => {
                this.hoveredCountryCode = null;
              },
            },
          },
        },
      },
      colorAxis: {
        min: 0,
        stops: [
          [0, '#f0fdf4'], // green-50
          [0.3, '#86efac'], // green-300
          [0.6, '#22c55e'], // green-500
          [1, '#15803d'], // green-700
        ],
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.name}</b>: {point.value} visitors',
      },
      series: [
        {
          type: 'map',
          name: 'Visitors',
          mapData: worldMap as any,
          joinBy: ['hc-key', 'hc-key'],
          states: {
            hover: {
              color: '#16a34a', // green-600
            },
          },
          dataLabels: {
            enabled: false,
          },
          allAreas: true,
          data: data,
        } as any,
      ],
    };
  }
}
